import { render } from "./CreateNetwork.vue?vue&type=template&id=3a18565e&scoped=true"
import script from "./CreateNetwork.vue?vue&type=script&lang=js"
export * from "./CreateNetwork.vue?vue&type=script&lang=js"

import "./CreateNetwork.vue?vue&type=style&index=0&id=3a18565e&scoped=true&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a18565e"]])

export default __exports__